import React from 'react';
import { Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import BudgetCodeValidationModal from 'pages/provisioning/_components/StackProvisioning/Form/BudgetCodeValidationModal';
import { OrderPayload, isBudgetCodeValid, budgetCodeValidationModal } from 'pages/reference-implementation/provisioning/RI004O/store';
import ApplicationSection from 'pages/reference-implementation/provisioning/RI004O/components/sections/Application';
import AccessMgmtSection from 'pages/reference-implementation/provisioning/RI004O/components/sections/AccessMgmtSection';
import ResourceMgmtSection from 'pages/reference-implementation/provisioning/RI004O/components/sections/ResourceMgmtSection';

const IndexForm = () => {
    const [, setOrder] = useRecoilState(OrderPayload);
    const [, setBudgetCodeValid] = useRecoilState(isBudgetCodeValid);
    const [budgetCodeValidation, setBudgetCodeValidation] = useRecoilState(budgetCodeValidationModal);

    const closeBudgetCodeValidation = (isAccepted) => {
        if (isAccepted) setOrder((prev) => ({ ...prev, enabledManualBudgetCode: true }));
        setBudgetCodeValid(isAccepted);
        setBudgetCodeValidation({ open: false, budgetCode: '' });
    };
    return (
        <Box flex={3} data-testid="index-form">
            <ApplicationSection />
            <ResourceMgmtSection />
            <AccessMgmtSection />
            <BudgetCodeValidationModal
                open={budgetCodeValidation.open}
                budgetCode={budgetCodeValidation.budgetCode}
                onContinue={() => closeBudgetCodeValidation(true)}
                onCancel={() => closeBudgetCodeValidation(false)}
            />
        </Box>
    );
};

export default IndexForm;
